import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SerializedStyles } from '@emotion/utils';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface BetSlipContentPropsType {
    isVisibleKeyboard: boolean;
    isMiniCasino: boolean;
    computedHeight: number;
}


const setBetSlipContent = (isVisibleKeyboard: boolean, isMiniCasino: boolean, computedHeight: number ): SerializedStyles => {
    if (isVisibleKeyboard) {
        return css`
            padding-bottom: calc(${computedHeight}px + 181px);
        `;
    }

    if (isMiniCasino) {
        return css`
            padding-bottom: 0;
        `;
    }

    return css`
        padding-bottom: 80px;
    `;
};

export const BetSlipContent = styled('div', { label: 'BetSlipContent' })<BetSlipContentPropsType>`
    ${({ isVisibleKeyboard, isMiniCasino, computedHeight }): SerializedStyles => setBetSlipContent(isVisibleKeyboard, isMiniCasino, computedHeight)};
`;

export const SelectionsList = withConfig(theme => styled('ul', { label: 'SelectionsList' })`
    color: ${theme.star.betslipSelectionList.txtColor};
    margin: 16px 0;
`);

export const CombinationsList = styled('ul', { label: 'CombinationsList' })`
    margin-top: 16px;
`;

interface BetslipButtonsAndMessageWrapperPropsType {
    computedHeight: number;
    isVisibleKeyboard: boolean;
}

export const BetslipButtonsAndMessageWrapper = withConfig(theme => styled('div', { label: 'BetslipButtonsAndMessageWrapper' })<BetslipButtonsAndMessageWrapperPropsType>`
    background: ${theme.star.betslipGeneral.bgColor};
    bottom: ${({ isVisibleKeyboard }): string => isVisibleKeyboard ? '201px' : '0'};
    height: ${({ computedHeight }): string => `${computedHeight}px`};
    left: 8px;
    position: ${({ isVisibleKeyboard }): string => isVisibleKeyboard ? 'fixed' : 'sticky'};
    right: 8px;
    z-index: 1;
    @media ${theme.star.mediaQuery.largeDesktop} {
        height: initial;
    }
`);

interface ErrorWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setErrorWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const ErrorWrapper = withConfig(theme => styled('div', { label: 'ErrorWrapper' })<ErrorWrapperPropsType>`
    ${({ variant }): SerializedStyles => setErrorWrapper(variant, theme)}
`);

